import React, { useEffect, useState } from 'react'
import { getAllArea, GetAllStates, GetAllTenants, GetAllUniversity, GetCategory, GetEducation, GetPrograms, SaveCategory, UpdateCategory, UpdateEducation, UpdatePrograms, UpdateStates, UpdateUniversity } from '../../../../services/CommonService';
import { toast, ToastContainer } from 'react-toastify';

function CloneComponent({ dataprops }) {
    const [data, setData] = useState([])
    const [selectedtenant, setSelectedTenant] = useState()
    const [fromsubappid, setFromsubappid] = useState("")
    const [tosubappid, setTosubappid] = useState("")
    const [fromareas, setFromAreas] = useState([])
    const [toareas, setToAreas] = useState([])
    const [tosubappname, setTosubappName] = useState([])


    useEffect(() => {
        getTenants()
        ToAreas()

    }, [])
    const notifyTopFullWidth = (message) => {
        toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };
    const getTenants = async () => {

        setData([]);
        const tenantdata = await GetAllTenants({ pageno: '-1' });
        console.log(data);
        setData(tenantdata.data);
    }

    const ToAreas = async () => {
        const reqdata = {
            pageno: "-1",
            query: { tenantid: dataprops.tenantid }
        }

        const AreaResponse = await getAllArea(reqdata)
        console.log("Areas  response", AreaResponse);
        setToAreas(AreaResponse.data)

    }

    const handleChange = async (e) => {
        setSelectedTenant(e.target.value);
        console.log("e.target.value", e.target.value);
        const reqdata = {
            pageno: "-1",
            query: { tenantid: e.target.value }
        }

        const AreaResponse = await getAllArea(reqdata)
        setFromAreas(AreaResponse.data)
        console.log("Areas To response", AreaResponse);
    }

    const addTenantIfNotExists = (item, dataprops) => {
        let tenantArray = Array.isArray(item.tenant)
            ? [...item.tenant]
            : item.tenant && typeof item.tenant === 'object'
                ? [item.tenant]
                : [];

        // Add tenant if not already present
        if (!tenantArray.some(t => t.value === dataprops.tenantid)) {
            tenantArray.push({ label: dataprops.name, value: dataprops.tenantid });
        }

        let updatedItem = { ...item, tenant: tenantArray };

        // If tosubappid is defined, update area too
        if (tosubappid) {
            let areaArray = Array.isArray(item.area)
                ? [...item.area]
                : item.area && typeof item.area === 'object'
                    ? [item.area]
                    : [];

            if (!areaArray.some(a => a.value === tosubappid)) {
                areaArray.push({ label: tosubappname, value: tosubappid });
            }

            updatedItem.area = areaArray;
        }

        return updatedItem;
    };


    const submitForm = async () => {
        let reqparams = ''
        reqparams = {
            pageno: '-1',
            query: { tenant: { $elemMatch: { value: selectedtenant } }, status: "Active" }
        };

        if (fromsubappid) {
            reqparams = {
                pageno: '-1',
                query: {
                    tenant: { $elemMatch: { value: selectedtenant } },
                    area: { $elemMatch: { value: fromsubappid } },
                    status: "Active"
                }
            };

        }

        const updateData = async (getterFunc, updaterFunc, label) => {
            try {
                const { data } = await getterFunc(reqparams);
                // console.log(`${label} response`, data);

                for (const item of data) {
                    const updatedItem = addTenantIfNotExists(item, dataprops);
                    // console.log("updatedItem", updatedItem);

                    const response = await updaterFunc(updatedItem);
                    console.log(`Updated ${label}`, response);
                }
            } catch (err) {
                console.error(`Error updating ${label}:`, err);
                
            }
            alert(`${label} cloned successfully.`);
            // notifyTopFullWidth(`${label} cloned successfully.`);
        };

        await updateData(GetCategory, UpdateCategory, "Category");
        await updateData(GetPrograms, UpdatePrograms, "Program");
        await updateData(GetEducation, UpdateEducation, "Education");
        await updateData(GetAllStates, UpdateStates, "States");
        await updateData(GetAllUniversity, UpdateUniversity, "University")

    };


    const handleToSelectChange = (e) => {
        const selectedId = e.target.value;
        const selectedName = e.target.options[e.target.selectedIndex].text;

        setTosubappid(selectedId);
        setTosubappName(selectedName)
    };


    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Select Tenant
                </label>
                <div className="col-lg-6" >

                    <select
                        value={selectedtenant} name='selectedtenant' onChange={handleChange} className="form-control">
                        <option value="">Select Tenant</option>
                        {data?.map((ele) => {
                            return <option
                                key={ele.tenantid}
                                value={ele.tenantid}

                            >
                                {ele.name}
                            </option>

                        })}
                    </select>

                </div>
            </div>
            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Cloned From College/Constituency
                </label>
                <div className="col-lg-6" >

                    <select
                        value={fromsubappid} name='fromsubappid' onChange={(e) => setFromsubappid(e.target.value)} className="form-control">
                        <option value="">Select College/Constituency</option>6
                        {fromareas?.map((ele) => {
                            return <option
                                key={ele.id}
                                value={ele.id}

                            >
                                {ele.name}
                            </option>

                        })}
                    </select>

                </div>
            </div>
            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Cloned To College/Constituency
                </label>
                <div className="col-lg-6" >

                    <select
                        value={tosubappid} name='tosubappid' onChange={handleToSelectChange} className="form-control">
                        <option value="">Select College/Constituency</option>
                        {toareas?.map((ele) => {
                            return <option
                                key={ele.id}
                                value={ele.id}

                            >
                                {ele.name}
                            </option>

                        })}
                    </select>

                </div>
            </div>

            <div className="form-group">
                <button onClick={submitForm} className="btn btn-primary" type="button"
                >Save</button>
            </div>

        </>
    )
}

export default CloneComponent